import Findable from '../mixins/Findable.js';
import { parseFilename } from '../utils/fileUtils.js';
class FileSystemClient {
    static service = 'file-system';
    apiClient;
    constructor(apiClient) {
        this.apiClient = apiClient;
    }
    count(params) {
        const endpoint = this.makeEndpoint('count');
        return this.apiClient.exec(endpoint, params);
    }
    findDistinct(params) {
        const endpoint = this.makeEndpoint('find-distinct');
        return this.apiClient.exec(endpoint, params);
    }
    copy(params) {
        const endpoint = this.makeEndpoint('copy');
        return this.apiClient.exec(endpoint, params);
    }
    copyMany(params) {
        const endpoint = this.makeEndpoint('copy-many');
        return this.apiClient.exec(endpoint, params);
    }
    move(params) {
        const endpoint = this.makeEndpoint('move');
        return this.apiClient.exec(endpoint, params);
    }
    moveMany(params) {
        const endpoint = this.makeEndpoint('move-many');
        return this.apiClient.exec(endpoint, params);
    }
    remove(params) {
        const endpoint = this.makeEndpoint('remove');
        return this.apiClient.exec(endpoint, params);
    }
    removeMany(params) {
        const endpoint = this.makeEndpoint('remove-many');
        return this.apiClient.exec(endpoint, params);
    }
    delete(params) {
        const endpoint = this.makeEndpoint('delete');
        return this.apiClient.exec(endpoint, params);
    }
    deleteMany(params) {
        const endpoint = this.makeEndpoint('delete-many');
        return this.apiClient.exec(endpoint, params);
    }
    addClasses(params) {
        const endpoint = this.makeEndpoint('add-classes');
        return this.apiClient.exec(endpoint, params);
    }
    removeClasses(params) {
        const endpoint = this.makeEndpoint('remove-classes');
        return this.apiClient.exec(endpoint, params);
    }
    setOwner(params) {
        const endpoint = this.makeEndpoint('set-owner');
        return this.apiClient.exec(endpoint, params);
    }
    setPrivileges(params) {
        const endpoint = this.makeEndpoint('set-privileges');
        return this.apiClient.exec(endpoint, params);
    }
    setUserPrivileges(params) {
        const endpoint = this.makeEndpoint('set-user-privileges');
        return this.apiClient.exec(endpoint, params);
    }
    addPrivileges(params) {
        const endpoint = this.makeEndpoint('add-privileges');
        return this.apiClient.exec(endpoint, params);
    }
    addUserPrivileges(params) {
        const endpoint = this.makeEndpoint('add-user-privileges');
        return this.apiClient.exec(endpoint, params);
    }
    removePrivileges(params) {
        const endpoint = this.makeEndpoint('remove-privileges');
        return this.apiClient.exec(endpoint, params);
    }
    removeUserPrivileges(params) {
        const endpoint = this.makeEndpoint('remove-user-privileges');
        return this.apiClient.exec(endpoint, params);
    }
    setImage(params) {
        const endpoint = this.makeEndpoint('set-image');
        return this.apiClient.exec(endpoint, params);
    }
    async uploadImage({ asset, ...rest }) {
        const filename = parseFilename(asset);
        const data = [];
        data.push({
            name: 'url',
            value: (await Promise.resolve(asset.slice())),
            filename,
        });
        data.push({ name: 'q', value: JSON.stringify(rest) });
        const endpoint = this.makeEndpoint('set-image');
        return await this.apiClient.upload(endpoint, data);
    }
    removeImage(params) {
        const endpoint = this.makeEndpoint('remove-image');
        return this.apiClient.exec(endpoint, params);
    }
    makeEndpoint(operation) {
        return `${FileSystemClient.service}/${operation}`;
    }
}
// Decorate service with mixins
const DecoratedClient = Findable(FileSystemClient);
export default DecoratedClient;
